import { useState, useMemo, useCallback } from 'react';
import { IActionLinksModel } from '../ActionLinkModels';

export interface IActionHoverHandler {
  (label: string): void;
}
export interface IShowsNestedOnHover extends IActionLinksModel {
  onHover?: IActionHoverHandler;
}

export type IShowNestedOnHoverProps = ReturnType<typeof ShowsNestedOnHover>;

export function ShowsNestedOnHover({ level, values, onHover }: IShowsNestedOnHover) {
  const nestingLevel = (level = level || 0);
  const [hoveredLabel, setShowingNested] = useState('');
  if (!values) {
    console.warn('An empty actions list was passed.');
  }
  const nestedKeys = useMemo(() => (values?.nested ? Array.from(values.nested.keys()) : []), [values]);
  const mouseOver: IActionHoverHandler = useCallback(
    (label: string) => {
      setShowingNested(label);
      onHover?.(label); // notify neighbor that self is hovered.
    },
    [onHover]
  );

  const onNeighborHover: IActionHoverHandler = useCallback(() => {
    setShowingNested(''); // if a neighboring menu set is hovered, close self.
  }, []);

  return { nestingLevel, hoveredLabel, nestedKeys, mouseOver, onNeighborHover };
}
